import { gql } from '@apollo/client';

export const HEALTH_CHECKUP_INSTITUTIONS = gql`
  query healthCheckupInstitutions($limit: Int, $page: Int, $search: HealthCheckupInstitutionSearchInput) {
    client {
      healthCheckupInstitutions(limit: $limit, page: $page, search: $search) {
        totalCount
        list {
          id
          healthCheckupInstitutionId
          name
          location
        }
      }
    }
  }
`;

export interface HealthCheckupInstitutionsQueryVariables {
  page?: number | null;
  limit?: number | null;
  search?: HealthCheckupInstitutionSearchInput | null;
}

export type SortOrder = 'asc' | 'desc';

export type SortColumn = 'health_checkup_institution_id' | 'full_name_kana' | 'joined_at';

interface HealthCheckupInstitutionSearchInput {
  sortOrder?: SortOrder | null;
  sortColumn?: SortColumn | null;
}

export interface HealthCheckupInstitutionsQueryResult {
  client: {
    healthCheckupInstitutions: {
      totalCount: number;
      list: HealthCheckupInstitution[];
    };
  };
}

export interface HealthCheckupInstitution {
  id: string;
  healthCheckupInstitutionId: string;
  name: string;
  location: string;
}
